import type { GuestSelectionOption } from "../../../utils/guests";

type GuestCountDisplayProps = {
  value: string;
  options: GuestSelectionOption[];
  onChange: (value: string) => void;
};

const GUEST_COUNT_LABEL = "\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e \u0433\u043e\u0441\u0442\u0435\u0439";

export default function GuestCountDisplay({ value, options, onChange }: GuestCountDisplayProps) {
  return (
    <div className="flex items-center gap-3 self-start sm:self-auto">
      <span className="text-xs font-semibold uppercase tracking-[0.08em] text-indigo-500">{GUEST_COUNT_LABEL}</span>
      <div className="inline-flex rounded-full border border-indigo-200 bg-white p-1 shadow-sm">
        {options.map((option) => {
          const isActive = value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className={[
                "rounded-full px-3 py-1 text-xs font-semibold transition",
                isActive ? "bg-indigo-600 text-white" : "text-slate-600 hover:bg-indigo-50",
              ].join(" ")}
              aria-pressed={isActive}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
